import { useState } from "react";
import { useSchedulingQuery as useQuery } from "./useSchedulingQuery";

// Cursor history is local; query pages are cached independently and never refetched as a growing list.
export default function useSchedulingPage(key, params, fetchPage, itemsKey, { enabled = true, limit = 10 } = {}) {
  const scope = JSON.stringify([key, params, limit]);
  const [state, setState] = useState({ scope: "", cursors: [undefined], index: 0 });
  const page = state.scope === scope ? state : { scope, cursors: [undefined], index: 0 };
  const query = useQuery([key, params, page.cursors[page.index], limit], async ({ signal, consistency }) => {
    const response = await fetchPage({ ...params, cursor: page.cursors[page.index], limit, signal, consistency });
    if (!Array.isArray(response?.[itemsKey])) throw new Error("Could not load scheduling results.");
    if (response.nextCursor != null && (typeof response.nextCursor !== "string" || page.cursors.includes(response.nextCursor))) throw new Error("Could not continue loading results.");
    return response;
  }, { enabled: enabled && !!params.organizationRef, staleTime: 30000, cacheTime: 300000, refetchOnWindowFocus: false, retry: false });
  return { ...query, data: query.data?.[itemsKey] || [], page: page.index,
    hasNext: !!query.data?.nextCursor, hasPrevious: page.index > 0,
    next: () => { if (query.data?.nextCursor && !query.isFetching) setState({ scope, cursors: [...page.cursors.slice(0,page.index+1), query.data.nextCursor], index: page.index+1 }); },
    previous: () => { if (page.index && !query.isFetching) setState({ ...page, index: page.index-1 }); },
  };
}
